/**
 * User: WangMeng
 * Desc: 上市公司财务情况概览----评分分布情况
 */
import styles from './score.scss';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { Col, Row, Spin } from 'antd';
import {SCORE_SORTS} from '../../../../constants/common';
import {RiskFraudType} from '../../../../constants/enum';
import { getPictureLink, isNotEmpty, paramFilter } from '../../../../utils/util';
import NoData from '../../../common/noData/NoData';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import { formatScoreDistOption } from '../common/formatEchartOption';
import CompanyTable from '../common/CompanyTable';
import SearchForm from './score/SearchForm';
import { getScoreSpread } from '../../../../services/regulatoryStatistical';

export default class Score extends PureComponent {
    constructor(props) {
        super(props);
        this.fakeEvents = { click: (e) => this.onBarClick(RiskFraudType.FRAUD, e) };
        this.riskEvents = { click: (e) => this.onBarClick(RiskFraudType.RISK, e) };
        this.state = {
            searchParams: {},
            selectTypeScore: {},
            loading: true,
            fraudOption: {},
            riskOption: {}
        };
    }

    resetLoading = () => {
        this.setState({
            loading: false
        });
    };

    onSearch = (searchParams) => {
        this.setState({
            searchParams
        }, () => {
            this.getData();
        });
    };

    getData = () => {
        const { searchParams } = this.state;
        this.setState({
            loading: true
        });

        getScoreSpread(paramFilter(searchParams)).then(data => {
            data = data || {};
            this.setState({
                fraudOption: formatScoreDistOption(data.fraudScore),
                riskOption: formatScoreDistOption(data.riskScore),
                loading: false
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    // 点击柱状图
    onBarClick = (type, e) => {
        const { componentType, targetType, value } = e;
        if (componentType !== 'xAxis' || targetType !== 'axisLabel') {
            return;
        }

        const { fraudOption, riskOption, selectTypeScore } = this.state;
        let newSelectTypeScore = {};

        if (type !== selectTypeScore.type || value !== selectTypeScore.score) {
            newSelectTypeScore = { type, score: value };
        }

        this.setCategoryStyle(fraudOption, newSelectTypeScore);
        this.setCategoryStyle(riskOption, newSelectTypeScore);

        this.setState({
            selectTypeScore: newSelectTypeScore,
            searchParams: { ...this.changeScoreParam(newSelectTypeScore) },
            fraudOption: { ...fraudOption },
            riskOption: { ...riskOption }
        });
    };

    // 根据选中的类型和分数改变样式
    setCategoryStyle = (option = {}, selectTypeScore) => {
        let data = option.xAxis && option.xAxis[0].data;
        data && data.forEach(d => {
            if (d.type === selectTypeScore.type && d.value === selectTypeScore.score) {
                d.textStyle = {
                    color: '#F99248'
                };
            } else {
                delete d.textStyle;
            }
        });
    };

    // 改变分数区间搜索参数
    changeScoreParam = (selectTypeScore) => {
        const { searchParams } = this.state;
        let { type = '', score = '' } = selectTypeScore;
        let newParams = { ...searchParams };
        let files = ['anaType', 'minScoreFake', 'maxScoreFake', 'minScoreRisk', 'maxScoreRisk'];

        files.forEach(f => delete newParams[f]);

        if(type && score) {
            let field = type === RiskFraudType.FRAUD ? 'Fake' : 'Risk';
            let values = score.split('-');
            newParams.anaType = type;
            newParams[`minScore${field}`] = values[0];
            newParams[`maxScore${field}`] = values[1];
        }

        return newParams;
    };

    getHandleColumn = () => {
        return {
            title: '查看画像',
            dataIndex: 'picture',
            width: 80,
            className: 'operation',
            render: (v, d) => <Link target="_blank" rel="noopener noreferrer" to={getPictureLink(d)}>查看</Link>
        };
    };

    render() {
        const { options } = this.props;
        const { searchParams, loading, fraudOption, riskOption } = this.state;

        return (
            <div>
                <SearchForm showSubType={true} options={options} onSearch={this.onSearch} onFail={this.resetLoading}/>

                <Row>
                    <Col span={12}>
                        <p className="wrap-title">财务舞弊评分分布</p>
                        <div className={styles.barEchart}>
                            {
                                loading ?
                                    <Spin /> :
                                    isNotEmpty(fraudOption) ?
                                        <BBDLineBar option={fraudOption} onEvents={this.fakeEvents}/> :
                                        <NoData />
                            }

                        </div>
                    </Col>
                    <Col span={12}>
                        <p className="wrap-title">财务风险评分分布</p>
                        <div className={styles.barEchart}>
                            {
                                loading ?
                                    <Spin /> :
                                    isNotEmpty(fraudOption) ?
                                        <BBDLineBar option={riskOption} onEvents={this.riskEvents}/> :
                                        <NoData />
                            }
                        </div>
                    </Col>
                </Row>

                <CompanyTable
                    searchParams={searchParams}
                    defaultSort={SCORE_SORTS.FRAUD[0]}
                    handleColumn={this.getHandleColumn()}
                />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/financialOverview/Score.jsx